import { render, staticRenderFns } from "./KitchenDisplaySystem.vue?vue&type=template&id=03545dcf&scoped=true"
import script from "./KitchenDisplaySystem.vue?vue&type=script&lang=js"
export * from "./KitchenDisplaySystem.vue?vue&type=script&lang=js"
import style0 from "./KitchenDisplaySystem.vue?vue&type=style&index=0&id=03545dcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03545dcf",
  null
  
)

export default component.exports